const DARK_QUERY = '(prefers-color-scheme: dark)';
const STYLE_ID = 'browser-color-scheme-style';
const ROOT_ATTR = 'data-color-scheme';

const DEFAULT_BACKGROUNDS = {
  light: '#ffffff',
  dark: '#2c2c2c',
};

export function getBrowserColorScheme() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return 'light';
  }

  return window.matchMedia(DARK_QUERY).matches ? 'dark' : 'light';
}

export default class BrowserColorSchemeService {
  constructor(options = {}) {
    this.backgrounds = {
      ...DEFAULT_BACKGROUNDS,
      ...(options.backgrounds || {}),
    };
    this.selectors = options.selectors || ['html', 'body', '#app', '.flow-page'];
    this.onSchemeChange = typeof options.onChange === 'function' ? options.onChange : null;
    this.mediaQuery = null;
    this.onChange = this.handleChange.bind(this);
  }

  start() {
    this.apply(getBrowserColorScheme());

    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return this;
    }

    this.mediaQuery = window.matchMedia(DARK_QUERY);

    if (this.mediaQuery.addEventListener) {
      this.mediaQuery.addEventListener('change', this.onChange);
    } else if (this.mediaQuery.addListener) {
      this.mediaQuery.addListener(this.onChange);
    }

    return this;
  }

  stop() {
    if (this.mediaQuery) {
      if (this.mediaQuery.removeEventListener) {
        this.mediaQuery.removeEventListener('change', this.onChange);
      } else if (this.mediaQuery.removeListener) {
        this.mediaQuery.removeListener(this.onChange);
      }
    }

    this.removeStyle();
    document.documentElement.removeAttribute(ROOT_ATTR);
    document.documentElement.style.removeProperty('color-scheme');
    this.mediaQuery = null;
  }

  handleChange(event) {
    this.apply(event.matches ? 'dark' : 'light');
  }

  apply(scheme) {
    const background = this.backgrounds[scheme] || this.backgrounds.light;

    document.documentElement.setAttribute(ROOT_ATTR, scheme);
    document.documentElement.style.setProperty('color-scheme', scheme);

    this.ensureStyleEl().textContent = `${this.selectors.join(', ')} { background: ${background} !important; }`;

    if (this.onSchemeChange) {
      this.onSchemeChange(scheme);
    }
  }

  ensureStyleEl() {
    let styleEl = document.getElementById(STYLE_ID);

    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = STYLE_ID;
      document.head.appendChild(styleEl);
    }

    return styleEl;
  }

  removeStyle() {
    const styleEl = document.getElementById(STYLE_ID);

    if (styleEl && styleEl.parentNode) {
      styleEl.parentNode.removeChild(styleEl);
    }
  }
}
